import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import type { Dispatch } from '@swf/core/store';
import type { InviteLink } from '@swf/core/types/Poker';
import { PokerModalRoutes } from '@swf/core/types/Poker';
import { PokerContext } from '@swf/poker';

const useInviteToClub = () => {
  const { modal } = useDispatch<Dispatch>();
  const { state: locationState } = useLocation<{
    clubId: string;
    invitationCode: string;
    type: InviteLink;
  }>();
  const {
    state: { fetchService }
  } = useContext(PokerContext);

  useEffect(() => {
    const clubId = locationState?.clubId;
    const invitationCode = locationState?.invitationCode;
    const type = locationState?.type;

    if (!clubId || !invitationCode || !type || type !== 'JOIN_CLUB') {
      return;
    }

    modal.enqueue({
      path: PokerModalRoutes.joinClub,
      locationState: { fetchService, clubId, invitationCode }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useInviteToClub;
